import axios from '../axios';
import config from '../../config';
const { leaderURL } = config;
export default {
  // 获取集训列表
  getTrainingsList(params) {
    return axios(leaderURL + `/trainings`, {
      method: 'get',
      params,
    });
  },
  // 获取女子球员集训列表
  getWomanTrainingsList(params) {
    return axios(leaderURL + `/woman/trainings`, {
      method: 'get',
      params,
    });
  },
  // 获取集训球员列表
  getTrainingsPlayer(trainingId, params) {
    return axios(leaderURL + `/training/team/${trainingId}/users`, {
      method: 'get',
      params,
    });
  },
};
